/* eslint-disable import/no-cycle */
/* eslint-disable react/display-name */
import React from 'react';

// eslint-disable-next-line import/no-cycle
import {
  AccordionIconCell,
  CheckBox,
  DeleteIconCell,
  DownloadIconCell,
  IconCell,
  IconCellChargerAction,
  IconCellChargerCable,
  LinkChargerDetail,
  LinkLeadDetail,
  ProgressIconCell,
  SeveralTextCell,
  StatusCellWithMenu,
  TextCell,
  ToggleAndTextCell,
  TruncateCell
} from './CellTypes';

const CellComponent = {
  text: props => <TextCell {...props} />,
  checkBox: props => <CheckBox {...props} />,
  status: props => <ToggleAndTextCell {...props} />,
  statusLead: props => <TextCell {...props} />,
  progress_icon: props => <ProgressIconCell {...props} />,
  delete_icon: props => <DeleteIconCell {...props} />,
  downloadable: props => <DownloadIconCell {...props} />,
  status_chargers: props => <TextCell {...props} />,
  icon: props => <IconCell {...props} />,
  accordion: props => <AccordionIconCell {...props} />,
  linkChargerDetail: props => <LinkChargerDetail {...props} />,
  linkLeadDetail: props => <LinkLeadDetail {...props} />,
  action_charger: props => <IconCellChargerAction {...props} />,
  cable: props => <IconCellChargerCable {...props} />,
  truncate_cell: props => <TruncateCell {...props} />,
  several_text: props => <SeveralTextCell {...props} />,
  status_menu: props => <StatusCellWithMenu {...props} />
};

export const Cell = props => {
  const { contentType } = props.cellData;

  return CellComponent[contentType]({ ...props, ...props.cellData });
};
